import styled from "styled-components";

export const SectionWrapper = styled.section`
  padding: 60px 0 85px;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 42px 0 55px;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 32px;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 24px;
    gap: 14px;
  }
`;

export const HeaderLeft = styled.div`
  max-width: 680px;
`;

export const Eyebrow = styled.span`
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  color: #D87B1C;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 6px;
`;

export const SectionTitle = styled.h2`
  font-family: "Playfair Display", Georgia, serif;
  font-size: 38px;
  font-weight: 700;
  color: #1c1917;
  line-height: 1.25;
  margin: 0;
  letter-spacing: -0.3px;

  span.highlight {
    color: #D87B1C;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;

  .view-blog-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 700;
    color: #D87B1C;
    text-decoration: none;
    transition: all 0.25s ease;
    padding: 8px 0;

    svg {
      transition: transform 0.25s ease;
    }

    &:hover {
      color: #b85f09;
      svg {
        transform: translateX(4px);
      }
    }
  }

  @media (max-width: 768px) {
    align-self: flex-start;
  }
`;

export const SwiperWrapper = styled.div`
  width: 100%;
  position: relative;

  .swiper {
    padding-bottom: 12px;
  }

  .swiper-slide {
    height: auto;
    display: flex;
  }
`;

export const BlogCard = styled.article`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: transparent;
  text-decoration: none;
  cursor: pointer;

  &:hover .card-image-box img {
    transform: scale(1.05);
  }

  &:hover .card-title {
    color: #D87B1C;
  }

  &:hover .read-link {
    color: #D87B1C;
    svg {
      transform: translateX(4px);
    }
  }
`;

export const CardImageBox = styled.div`
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 20px;
  overflow: hidden;
  background: #f5f5f4;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid #ECE7DF;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.45s cubic-bezier(0.16, 1, 0.3, 1);
  }
`;

export const CardContent = styled.div`
  padding: 18px 4px 6px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const PostDate = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #D87B1C;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 8px;
  display: block;
`;

export const PostTitle = styled.h3`
  font-family: "Playfair Display", Georgia, serif;
  font-size: 20px;
  font-weight: 700;
  color: #1c1917;
  line-height: 1.35;
  margin: 0 0 12px 0;
  transition: color 0.25s ease;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const ReadArticleLink = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #57534e;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: auto;
  transition: color 0.25s ease;

  svg {
    font-size: 12px;
    transition: transform 0.25s ease;
  }
`;

export default SectionWrapper;
